<template>
<div class="certificate">
<div style="min-height: calc(100% - 220px);box-sizing: border-box;">
  <div class="assessTit">
    <div class="commonW" style="padding-top:16px;">
      <div class="left">
        <img src="../assets/wangLG.png" />
      </div>
     <div class="right"><span><img src="../assets/tel.png" /></span>  400-777-5999</div>
    </div>
  </div>
  <div class="commonW">
  <!-- 常见问题 -->
  <div class="step03" style="max-width:900px;margin:0 auto;">
    <div class="title">常见问题</div>
    <div class="stepQues">
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item title="如何查看找到项目编号及安全码信息？" name="1">
            <div>项目编号及安全码，可以在线下平台激活卡获取，激活卡随着产品销售同步配套发货。</div>
            <div>
              <el-card class="box-card" shadow="never">
                <div>
                  <div>使用须知：</div>
                  <div  >1、软件下载安装：</div>
                  <div>下载地址：http://gofile.me/2UNgV/GrTDZkTLA</div>
                  <div  >2、软件证书获取：</div>
                  <div>证书网址：https://cert.jia-r.com/search</div>
                  <div >3、软件激活：</div>
                  <div>导入证书文件，软件激活成功</div>
                  <div style="margin-top:20px;">
                    <span>项目编号：12211221</span>
                    <span style="margin-left:100px">安全码：</span>
                    <span class="safeCode">12211221</span>
                  </div>
                </div>
              </el-card>
            </div>
            <div class="tipBox">
                    <div></div>
                    项目编号、安全码信息
                </div>
            <div @click="showFunc(1)" class="showFunc" style="margin-top:50px;">收起</div>
           </el-collapse-item>
          <el-collapse-item title="如何查找到电脑特征码？" name="2">
            <div>电脑特征码需要按照线下管理平台软件，打开软件系统将自动弹出。您可以复制或者保存电脑特征码值。</div>
            <div>
              <img src=".././assets/cer.png" alt="" style="margin-top:20px;width:500px;height:366px;">
            </div>
            <div class="tipBox" style="top: -130px;left: 578px;">
                <div style="width:80px;left:-80px;"></div>
                电脑特征值
            </div>
            <div @click="showFunc(2)" class="showFunc" style="margin-top:50px;">收起</div>
          </el-collapse-item>
          <el-collapse-item title="证书类型区别是什么？" name="3">
            <div>工程调试证书：属于项目施工阶段工程人员安装调试时间使用，有效期为15天。</div>
            <div style="height:60px">正式证书：线下平台服务器正式使用激活使用</div>
            <div @click="showFunc(3)" class="showFunc">收起</div>
          </el-collapse-item>
        </el-collapse>
    </div>
  </div>
  </div>
  </div>
  <div class="footer clear-fix" style="width:100%;min-width:1100px;">
    <div style="max-width:1100px;margin:0 auto;">
      <div class="aboutUs">
        <div class="title">关于我们</div>
        <div><a style="color: #C0C0C0;" target="_blank" href="http://www.itlong.com.cn/about.html" rel="noopener noreferrer">企业介绍</a></div>
        <div><a style="color: #C0C0C0;" target="_blank" href="http://www.itlong.com.cn/qiyewenhua.html" rel="noopener noreferrer">企业文化</a></div>
        <div><a style="color: #C0C0C0;" target="_blank" href="http://www.itlong.com.cn/zizhirongyu.html" rel="noopener noreferrer">资质荣誉</a></div>
        <div><a style="color: #C0C0C0;" target="_blank" href="http://www.itlong.com.cn/hezuohuoban73.html" rel="noopener noreferrer">合作伙伴</a></div>
        <div><a style="color: #C0C0C0;" target="_blank" href="http://www.itlong.com.cn/pinpaiziyuan.html" rel="noopener noreferrer">品牌资源</a></div>
      </div>
      <div class="footerBor footerBor1"></div>
      <div class="concatUs">
        <div class="title">联系我们</div>
        <div>总　　机　0755-86675999 </div>
        <div>销售邮箱　shangwu@itlong.com.cn</div>
        <div>售后邮箱　fw@itlong.com.cn</div>
        <div>总部地址　深圳市南山区高新南七道数字技术园B1栋5楼A区</div>
        <div>邮　　编　518055   </div>
      </div>
      <div class="footerBor footerBor2"></div>
      <div class="company">
        <div>Copyright © 1997-2021 版权所有:深圳市旺龙智能科技有限公司</div>
        <div>粤ICP备18085992号</div>
        <div>旺龙智能-为您提供智能云梯控，云门禁，云对讲报价、价格、采购，智能云梯控、云门禁、云对讲品牌商，厂家，供应商，批发商！</div>
      </div>
    </div>
  </div>
  
 
 </div>
</template>
<script>

  export default {
    data() {
      
      return {
        activeName:'',
      };
    },

    methods: {
     
      showFunc(){
        this.activeName='';
      },
      
    },
    mounted(){
      this.activeName=window.atob(this.$route.query.activeName)
    },
  }
</script>
<style scoped>
  .certificate{
    height:100%;
    background:#fff;
    overflow:hidden; 
    overflow-y:auto;
    min-width:1100px;
    width:100%;
  }
  .commonW{
    min-width:1100px;
    max-width:1100px;
    margin:0 auto;
  }
  .el-table-add-row {
    width:85%;float:right;
    height: 34px;
    border: 1px dashed #c1c1cd;
    border-radius: 3px;
    cursor: pointer;
    justify-content: center;
    display: flex;
    line-height: 34px;
  }
  /* 弹框样式 */
  .myToast {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;
    width: 100%;
    height: 100%;
    display: flex;    
    display: -webkit-flex; /* Safari */
    -webkit-align-items: center; /* Safari 7.0+ */
    align-items: center;
    justify-content: center;
    -webkit-justify-content: center; /* Safari 6.1+ */
  }
  .myToast .error{
    max-width: 300px;
    min-width: 100px;
    background: rgba(0, 0, 0, 0.8);
    padding: 8px 15px;
    text-align: center;
    color: white;
    font-size: 16px;
    border-radius: 5px;
  }
  .assessTit{
    width:100%;
    height:80px;
    margin-bottom:50px;
    background:rgba(255,255,255,1);
    border-bottom:1px solid rgba(190,190,190,1);
  }
  .assessTit img{
    width:250px;
    margin-top:8px;
  }
  .assessTit .left{
    float: left;
  }
  .assessTit .left span{
    display:inline-block;width:1px; height:26px;background:rgba(197,197,197,1);margin:0 10px;
  }
  .assessTit .font{
    font-size: 26px;
    color: #2E2E2E;
    letter-spacing:8px;
    margin-top:8px;
  }
  .assessTit .right{
    float: right;
    font-size: 20px;
    color:#2E2E2E;
  }
  .assessTit .right span{
    display: inline-block;
    width:40px;
    height:40px;
    background:rgba(255,255,255,1);
    border:1px solid #BEBEBE;
    border-radius:50%;
    text-align: center;
  }
  .assessTit .right img{
    width:16px;
    margin-top:12px;
  }
 
  .step03  .title{
    width:100%;
    text-align: center;
    font-size: 28px;
    margin-bottom:40px;
  }
  .step03 .box-card{
    width:400px;
    margin-top:20px;
    padding:10px;
    border-radius: 30px;
    border: 1px solid #666;
  }
  .step03 .box-card .safeCode{
    display: inline-block;
    width: 70px;
    height:26px;
    line-height:26px;
    background:#ececec;
    text-align:center;
    border-radius:3px;
  }
  .tipBox{
    display: inline-block;
    width:200px;
    height:50px;
    line-height:50px;
    text-align:center;
    border-radius:30px;
    border:1px dashed #1518b8;
    background: #fff;
    position: relative;
    top: -73px;
    left: 567px;
  }
  .tipBox div{
    width:180px;
    border-bottom:1px dashed #1518b8;
    position: absolute;
    left:-180px;
    top:25px;
  }
  .securityInfo{
    display:inline-block;
    vertical-align: top;
    margin-left:50px;
    width:500px;
  }
  .box-card .info{
    height: auto;
    margin-bottom:22px;
  }
  .textBreak{
        text-align:justify;
        word-break:break-all;
        overflow: hidden;
  }
  .showFunc{
    width:50px;
    height:40px;
    line-height:40px;
    float: right;
    text-align: center;
    color:rgba(6, 6, 243, 0.753);
    cursor:pointer
  }
  .gree{color:#67C23A;}
  .red{color: #de0f0f;}
  
  .footer{
    min-width:1100px;
    max-width:100%;
    height:200px;
    background: #31373A;
    z-index: 99999;
    margin-top:20px;
    padding-top:30px;
    box-sizing: border-box;
    color: #C0C0C0;
  }
  .footer .aboutUs,.footer .concatUs,.footer .company{
    float: left;
  }
  .footer .aboutUs div,.footer .concatUs div,.footer .company div{
    margin-bottom:5px;
  }
  .footer .title{
    color:#fff;margin-bottom:15px!important;
  }
  .footer .aboutUs{
    width: 60px;
  }
  .footer .concatUs{
    width: 380px;
  }
  .footer .company{
    width: calc(100% - 600px);
    margin-top:30px;
  }
  .footer .footerBor{
    float: left;
    width: 1px;
    height: 130px;
    background: #616161;
    margin:0 39px;
    margin-top:20px;
  }
  /*清除浮动*/
.clear-fix::after {
  content: ".";    
  display: block;  
  clear: both;     
  visibility: hidden;      
  height: 0;   
  font-size:0;    
}
.spanBtn{
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #FFF;
    border: 1px solid #DCDFE6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
}
.spanBtn.primary{
    color: #FFF;
    background-color: #409EFF;
    border-color: #409EFF;
}
.el-collapse{
  border:none;
}
.itemlabel{
  display: inline-block;
  color:#333;
  font-size: 18px;
}
</style>
<style>
 
  a{
    text-decoration:none;
  }
  .step01 .el-input__inner{
    border: none;
    border-bottom: 1px solid #DCDFE6;
    border-radius: 0;
  }
  .step02 .el-table th{
    padding: 4px 0;
  }
  .stepQues .el-collapse-item__header,.stepQues .el-collapse-item__wrap{
    border: none;
  }
  .stepQues .el-collapse-item__header{
    font-size: 16px;
  }
  .stepQues .el-collapse-item__content{
    background: #f3f3f3;
    padding:20px 15px;
    padding-bottom:40px;
    color: #606266;
  }
  html,body{
    height: auto;
  }
</style>


// WEBPACK FOOTER //
// Question.vue?0e8ded4c